import { Address } from '~/basket/model/session/reducers'
import { keyMirror } from '~/util/helpers/keyMirror'
import { Profile } from './reducers'

export const ACTION = keyMirror(
  {
    UPDATE_PROFILE_REQUESTED: null,
    UPDATE_PROFILE_SUCCESS: null,
    UPDATE_PROFILE_FAILURE: null,
    UPDATE_PROFILE: null,
    UPDATE_PROFILE_ADDRESS: null,
  },
  'profile'
)

export const updateProfileRequested = () => ({
  type: ACTION.UPDATE_PROFILE_REQUESTED,
})

export const updateProfileSuccess = (profile: Profile) => ({
  type: ACTION.UPDATE_PROFILE_SUCCESS,
  payload: {
    profile,
  },
})

export const updateProfileFailure = (error: unknown) => ({
  type: ACTION.UPDATE_PROFILE_FAILURE,
  error: true,
  payload: error,
})

export type UpdateProfileOptions = {
  hasUpdatedPostalCode?: boolean
  isSubmitted?: boolean
}

export const updateProfile = (profile: Profile, options: UpdateProfileOptions) => ({
  type: ACTION.UPDATE_PROFILE,
  payload: {
    profile,
    options,
  },
})

export const updateProfileAddress = (address: Partial<Address>) => ({
  type: ACTION.UPDATE_PROFILE_ADDRESS,
  payload: {
    address,
  },
})
